(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["oenum-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('oenum-delivery')) return;

    const STORE_KEY = 'oenum:pincode';
    const DAY = 86400000;

    const store = {
      get() { try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } },
      set(v) { try { localStorage.setItem(STORE_KEY, v); } catch (e) {} },
      clear() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }
    };

    // Current time in India, independent of the device's own timezone.
    function istNow() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kolkata', hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date());
      const p = {};
      parts.forEach((x) => { p[x.type] = x.value; });
      return {
        date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
        secs: (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second)
      };
    }

    const iso = (d) => d.toISOString().slice(0, 10);
    const fmt = (d) => d.toLocaleDateString('en-IN', {
      weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'
    }).replace(',', '');

    function fill(tpl, vars) {
      return String(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
    }

    class OenumDelivery extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        const cfgEl = this.querySelector('[data-config]');
        if (!cfgEl) return;
        try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

        const c = this.cfg;
        this.prefixes = String(c.prefixes || '')
          .split(/[\s,]+/).map((s) => s.replace(/\D/g, '')).filter(Boolean);
        this.holidays = new Set(
          String(c.holidays || '').split(/[\s,]+/).map((s) => s.trim()).filter(Boolean)
        );

        this.form = this.querySelector('[data-form]');
        this.input = this.querySelector('[data-input]');
        this.err = this.querySelector('[data-error]');
        this.result = this.querySelector('[data-result]');
        this.live = this.querySelector('[data-live]');
        if (!this.form) return;

        this.input.addEventListener('input', () => {
          const clean = this.input.value.replace(/\D/g, '').slice(0, 6);
          if (clean !== this.input.value) this.input.value = clean;
          this.showError(false);
        });

        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.check(this.input.value);
        });

        this.querySelector('[data-change]').addEventListener('click', () => this.reset());

        const saved = c.remember ? store.get() : '';
        if (/^\d{6}$/.test(saved)) {
          this.input.value = saved;
          this.check(saved, true);
        }
      }

      disconnectedCallback() { clearInterval(this._timer); }

      isWorking(d) {
        if (this.cfg.skipSundays && d.getUTCDay() === 0) return false;
        return !this.holidays.has(iso(d));
      }

      addWorking(d, n) {
        let x = new Date(d.getTime());
        let left = Math.max(0, parseInt(n, 10) || 0);
        while (left > 0) {
          x = new Date(x.getTime() + DAY);
          if (this.isWorking(x)) left -= 1;
        }
        return x;
      }

      isExpress(pin) {
        return this.cfg.showExpress && this.prefixes.some((p) => pin.indexOf(p) === 0);
      }

      showError(on) {
        if (!this.err) return;
        this.err.hidden = !on;
        this.toggleAttribute('data-error', on);
        this.input.setAttribute('aria-invalid', on ? 'true' : 'false');
      }

      setActiveRow(name) {
        this.querySelectorAll('[data-row]').forEach((row) => {
          row.classList.toggle('is-active', row.dataset.row === name);
        });
      }

      check(raw, silent) {
        const pin = String(raw || '').replace(/\D/g, '');
        if (!/^[1-9]\d{5}$/.test(pin)) {
          if (!silent) { this.showError(true); this.input.focus(); }
          return;
        }
        this.showError(false);
        this.pin = pin;
        if (this.cfg.remember) store.set(pin);
        this.render();
        clearInterval(this._timer);
        if (this.cfg.countdown && this.isExpress(pin)) {
          this._timer = setInterval(() => this.render(true), 30000);
        }
      }

      render(quiet) {
        const c = this.cfg;
        const m = c.msg;
        const now = istNow();
        const today = now.date;
        const cutSecs = (parseInt(c.cutoffHour, 10) || 0) * 3600;
        const onTime = this.isWorking(today) && now.secs < cutSecs;
        const pinLine = fill(m.pin, { pincode: this.pin });

        let title;
        let sub;

        if (this.isExpress(this.pin)) {
          const dispatch = onTime ? today : this.addWorking(today, 1);
          const arrive = this.addWorking(dispatch, c.expressDays);
          const diff = Math.round((arrive - today) / DAY);
          let when = fmt(arrive);
          if (diff === 1) when = m.tomorrow + ', ' + when;
          if (diff === 0) when = m.today + ', ' + when;

          title = fill(m.expressOnTime, { when: when, date: fmt(arrive) });
          if (onTime) {
            const left = cutSecs - now.secs;
            const h = Math.floor(left / 3600);
            const mins = Math.max(1, Math.floor((left % 3600) / 60));
            const countdown = (h > 0 ? h + ' h ' : '') + mins + ' min';
            sub = fill(m.expressOnTimeSub, { countdown: countdown, cutoff: c.cutoffLabel });
          } else {
            sub = fill(m.expressLateSub, { cutoff: c.cutoffLabel });
          }
          this.setActiveRow('express');
          this.dataset.state = onTime ? 'express' : 'express-late';
        } else {
          const start = this.addWorking(today, c.standardMin);
          const end = this.addWorking(today, Math.max(c.standardMax, c.standardMin));
          const range = iso(start) === iso(end) ? fmt(end) : fmt(start) + ' – ' + fmt(end);
          title = fill(m.standard, { range: range, start: fmt(start), end: fmt(end) });
          sub = fill(m.standardSub, { min: c.standardMin, max: c.standardMax });
          this.setActiveRow('standard');
          this.dataset.state = 'standard';
        }

        this.querySelector('[data-result-title]').textContent = title;
        this.querySelector('[data-result-sub]').textContent = sub;
        this.querySelector('[data-result-pin]').textContent = pinLine;
        this.form.hidden = true;
        this.result.hidden = false;
        if (!quiet && this.live) this.live.textContent = title + '. ' + sub;
      }

      reset() {
        clearInterval(this._timer);
        this.pin = '';
        if (this.cfg.remember) store.clear();
        this.result.hidden = true;
        this.form.hidden = false;
        this.dataset.state = 'default';
        this.setActiveRow(this.cfg.showExpress ? 'express' : 'standard');
        this.input.value = '';
        this.input.focus();
      }
    }

    customElements.define('oenum-delivery', OenumDelivery);
  })();
  } catch(e) { console.error(e); }
})();

})();
